import { fetchBaseQuery } from "@reduxjs/toolkit/query";
import { Mutex } from 'async-mutex';

import { IsProdMode, ISUAT } from "./helper/environment/IsProdMode";
export { IsProdMode, ISUAT };

import { getAuthProps } from "../auth/authService";
import { getExternalAppUrl } from "./helper/externalUrl/ExternalUrlConfig";

const mutex = new Mutex();

// const authData = {
//     token: "eyJhbGciOiJIUzUxMiJ9.eyJFTUFJTCI6ImRhcnNoYW4ua2hhdGFyaUBneWFuZGlrc2hhLmluIiwiSUQiOjI1NTM5LCJBUEFBUl9JRCI6IiIsIlVTS19JRCI6IlVTSzY5OUMwM0FDOTgwNCIsIlJPTEVfSUQiOjIsInN1YiI6ImRhcnNoYW4ua2hhdGFyaUBneWFuZGlrc2hhLmluIiwiaWF0IjoxNzg0Nzg3MjI0LCJleHAiOjE3ODQ4NzM2MjR9.UXnkRN9zbtZDYx-T0DsooRP5VZDNlrDX0q9VDvUtgMvQqSbFYiSxGi9XC6mxirTOCHehIVno9fT6so7bD0TvRQ"
// }

// Factory function — accepts config from each app
export function createBaseQueries({ apiUrl, customBaseUrl, externalURLType }) {

    const rawBaseQuery = fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: (headers) => headers,
    });

    const rawDefaultBaseQuery = fetchBaseQuery({
        baseUrl: apiUrl,
        prepareHeaders: (headers) => {
            const authData = getAuthProps();
            if (authData) {
                headers.set("Authorization", `Bearer ${authData.token}`);
            }
            return headers;
        },
    });

    const rawExternalApiBaseQuery = fetchBaseQuery({
        baseUrl: getExternalAppUrl(externalURLType),
        prepareHeaders: (headers) => {
            const authData = getAuthProps();
            if (authData) {
                headers.set("Authorization", `Bearer ${authData.token}`);
            }
            return headers;
        },
    });

    const baseQuery = async (args, api, extraOptions) => {
        if (!(args.body instanceof FormData)) {
            args.headers = { ...args.headers, 'Content-Type': 'application/json' };
        }
        return rawBaseQuery(args, api, extraOptions);
    };

    const defaultBaseQuery = async (args, api, extraOptions) => {
        if (!(args.body instanceof FormData)) {
            args.headers = { ...args.headers, 'Content-Type': 'application/json' };
        }
        return rawDefaultBaseQuery(args, api, extraOptions);
    };

    const rawCustomFetchBase = fetchBaseQuery({
        baseUrl: customBaseUrl,
        prepareHeaders: (headers) => {
            const authData = getAuthProps();
            if (authData) {
                headers.set("Authorization", `Bearer ${authData.token}`);
            }
            return headers;
        },
    });

    const customFetchBase = async (args, api, extraOptions) => {
        const authData = getAuthProps();
        const token = authData?.token?.token ?? null;

        await mutex.waitForUnlock();

        args.headers = {
            ...args.headers,
            Authorization: `Bearer ${token}`,
        };

        if (!(args.body instanceof FormData)) {
            args.headers['Content-Type'] = 'application/json';
        }

        return rawBaseQuery(args, api, extraOptions);
    };

    return { baseQuery, defaultBaseQuery, customFetchBase, rawCustomFetchBase, rawExternalApiBaseQuery };
}
